

export const ANALYTICS_EVENTS = {
  // Authentication
  LOGIN_SUCCESS: "login_success",
  LOGIN_FAILED: "login_failed",
  LOGOUT: "logout",

  // Navigation
  SCREEN_VIEW: "screen_view",

  // Sidebar menu — one dynamic event per tab, see buildMenuTabClickedEvent
  // below (e.g. dashboard_tab_clicked, ecg_reports_tab_clicked).

  // ECG reports
  ECG_REPORT_CARD_CLICKED: "ecg_report_card_clicked",
  FULL_REPORT_VIEWED: "full_report_viewed",
  REPORT_DOWNLOADED: "report_downloaded",

  // Interpretation
  INTERPRETATION_REQUESTED: "interpretation_requested",
  INTERPRETATION_REQUEST_FAILED: "interpretation_request_failed",

  // Cases — names shared with the Android app, do not diverge
  REFERRED_CASE_CREATED: "referred_case_created",
  REFERRED_CASE_CLOSED: "referred_case_closed",
  // Web only: the app has no case-invite surface.
  DOCTOR_INVITED_TO_CASE: "doctor_invited_to_case",

  // Organisation (web only)
  MEMBER_ADDED: "member_added",
  CENTRE_ADDED: "centre_added",

  // Test collection request flow
  NEW_TEST_COLLECTION_REQUEST_CLICKED: "create_new_test_collection_request_clicked",
  CENTRE_SELECTED: "center_selected",
  PATIENT_SELECTED: "patient_selected",
  SEARCH_BUTTON_CLICKED: "search_button_clicked",
  PATIENT_SEARCH_FOUND: "patient_search_found",
  PATIENT_SEARCH_EMPTY: "patient_search_empty",
  PATIENT_SEARCH_ERROR: "patient_search_error",
  CREATE_NEW_PROFILE: "create_new_profile",

  // Test collection request flow — OTP verification
  SEND_OTP_CLICKED: "patient_verification_send_otp_clicked",
  SEND_OTP_SUCCESS: "patient_verification_send_otp_success",
  RESEND_OTP_CLICKED: "patient_verification_resend_otp_clicked",
  SEND_OTP_FAILED: "patient_verification_send_otp_failed",
  VERIFY_OTP_BUTTON_CLICKED: "patient_verification_verify_otp_button_clicked",
  OTP_VERIFIED: "patient_verification_otp_verified",
  OTP_VERIFICATION_FAILED: "patient_verification_otp_verification_failed",

  // Test collection request flow — ABHA verification
  VERIFY_PATIENT_THROUGH_ABHA: "verify_patient_through_abha",
  VERIFY_PATIENT_THROUGH_ABHA_SUCCESS: "verify_patient_through_abha_success",

  // Test collection request flow — patient profile
  PATIENT_DETAILS_FETCHED: "patient_details_fetched",
  CREATE_NEW_PROFILE_FORM_FILLED: "create_new_profile_form_filled",

  // Test collection request flow — additional details
  ADD_ADDITIONAL_DETAILS_CLICKED: "add_additional_details_clicked",
  ADDITIONAL_DETAILS_ADDED: "additional_details_added",

  // Test collection request flow — collection creation
  CREATE_COLLECTION: "create_collection",

  // In-house interpretation
  IN_HOUSE_INTERPRET_CLICKED: "in_house_interpret_clicked",
  IN_HOUSE_INTERPRETATION_EDIT: "in_house_interpretation_edit",
  IN_HOUSE_INTERPRETATION_SAVED_SUCCESSFULLY:
    "in_house_interpretation_saved_successfully",

  // Referred cases
  DOCTOR_REMOVED_FROM_CASE: "doctor_removed_from_case",
};

export const INTERPRETATION_SAVE_SOURCE = {
  INTERPRET: "interpret",
  EDIT: "edit",
};

export const PATIENT_TYPE = {
  NEW: "new",
  EXISTING: "existing",
};

export const CREATE_PROFILE_METHOD = {
  PHONE_NUMBER: "phone_number",
  ABHA: "abha",
  GUEST: "guest",
};

export const PATIENT_DETAILS_FETCH_METHOD = {
  AFTER_VERIFICATION: "after_verification",
  ALREADY_VERIFIED: "already_verified",
  THROUGH_ABHA: "through_abha",
};

export const COLLECTION_SOURCE = {
  GUEST: "guest",
  VERIFIED: "verified",
  NEW_PATIENT: "new_patient",
};

export const LOGIN_METHOD = {
  OTP: "otp",
  PASSWORD: "password",
};

export const LOGOUT_TRIGGER = {
  MANUAL: "manual",
  SESSION_EXPIRY: "session_expiry",
};

export const REPORT_TYPE = {
  ECG_REPORT: "ecg_report",
  AI_REPORT: "ai_report",
  PRESCRIPTION: "prescription",
};

export const INTERPRETER_TYPE = {
  SPANDAN_DOCTOR: "spandan_doctor",
  IN_HOUSE: "in_house",
  EXTERNAL: "external",
};

export const resolveInterpreterType = (userType) => {
  if (!userType || userType === "unknown") return NOT_SET;

  const value = String(userType).toLowerCase();
  if (value.includes("spandan")) return INTERPRETER_TYPE.SPANDAN_DOCTOR;
  if (["center", "centre", "in_house", "inhouse", "b2b-doctor", "member"].includes(value))
    return INTERPRETER_TYPE.IN_HOUSE;
  return INTERPRETER_TYPE.EXTERNAL;
};

export const FULL_REPORT_SOURCE = {
  PREVIEW: "preview",
  DIRECT: "direct",
};


export const VIEW_MODE = {
  CARD: "card",
  LIST: "list",
};

export const CENTRE_TYPE = {
  HUB: "hub",
  SPOKE: "spoke",
};

/** Stand-in for a value we genuinely do not have — see NOT_SET in ./index.js. */
export const NOT_SET = "none";

/**
 * Sidebar menu clicks are logged as a dynamic event per tab rather than one
 * generic event, so each item shows up as its own row in GA4/Firebase
 * (dashboard_tab_clicked, ecg_reports_tab_clicked, ...).
 */
export const buildMenuTabClickedEvent = (tabName) => {
  const slug = String(tabName || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

  return slug ? `${slug}_tab_clicked` : null;
};
